export const participantResolverErrorTest = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (desyncdata !== undefined) {
		if (desyncdata.indexOf('ValueError: Trying to use') !== -1 && (desyncdata.indexOf('AwayActionResolver without a valid type') !== -1 || desyncdata.indexOf('SingleSimResolver with unsupported participant') !== -1
			|| desyncdata.indexOf('DoubleSimResolver with unsupported participant') !== -1 || desyncdata.indexOf('DataResolver with type that is not supported by DataResolver') !== -1
			|| desyncdata.indexOf('SingleObjectResolver with something that is not an Object') !== -1 || desyncdata.indexOf('DoubleObjectResolver with something that is not supported') !== -1
			|| desyncdata.indexOf('SingleActorAndObjectResolver with something that is not supported') !== -1)) {

			var resolverType = 'Unknown'

			if (desyncdata.indexOf('AwayActionResolver') !== -1) {
				resolverType = 'AwayActionResolver'
			} else if (desyncdata.indexOf('SingleSimResolver') !== -1) {
				resolverType = 'SingleSimResolver'
			} else if (desyncdata.indexOf('DoubleSimResolver') !== -1) {
				resolverType = 'DoubleSimResolver'
			} else if (desyncdata.indexOf('DataResolver') !== -1) {
				resolverType = 'DataResolver'
			} else if (desyncdata.indexOf('SingleObjectResolver') !== -1) {
				resolverType = 'SingleObjectResolver'
			} else if (desyncdata.indexOf('DoubleObjectResolver') !== -1) {
				resolverType = 'DoubleObjectResolver'
			} else if (desyncdata.indexOf('SingleActorAndObjectResolver') !== -1) {
				resolverType = 'SingleActorAndObjectResolver'
			}

			return {
				type: 'participantResolverErrorTest' + resolverType,
				color: 'IndianRed',
				title: 'Participant Resolver Type Error',
				text: 'Outdated mod need to be fixed.',
				description: 'An outdated modification is providing participant data into a \'' + resolverType + '\' while the resolver expects different participant data.<br/>' +
				'The mod creator is required to fix this error.<br/><br/>' +
				'You need to locate the PACKAGE file, in your The Sims 4 Mods folder, that could be causing this issue and remove it.<br/>' +
				'If this is a new issue, try removing the most recent mod you have installed.'
			}
		}
	}
}

// EXAMPLE
/*
<root>
		<report>
				<version>2</version>
				<sessionid>ce8542982df084365ba2b34a</sessionid>
				<type>desync</type>
				<sku>ea.maxis.sims4_64.15.pc</sku>
				<createtime>2099-09-19 17:54:46</createtime>
				<buildsignature>Local.Unknown.Unknown.1.99.18.1020-1.200.000.364.Release</buildsignature>
				<categoryid>resolver.py:819</categoryid>
				<desyncid>ce8542982df084365ba2b34a</desyncid>
				<systemconfig/>
				<screenshot/>
				<desyncdata>Exception in Sim Timeline: Exception running Element (ValueError: Trying to use SingleObjectResolver with something that is not an Object: ParticipantType.Actor)
Traceback (most recent call last):
	File &quot;T:\InGame\Gameplay\Scripts\Server\scheduling.py&quot;, line 212, in simulate
	File &quot;T:\InGame\Gameplay\Scripts\Server\alarms.py&quot;, line 260, in _run
	File &quot;T:\InGame\Gameplay\Scripts\Server\statistics\continuous_statistic.py&quot;, line 725, in _alarm_callback
	File &quot;T:\InGame\Gameplay\Scripts\Server\statistics\continuous_statistic.py&quot;, line 746, in _trigger_callback
	File &quot;T:\InGame\Gameplay\Scripts\Server\statistics\base_statistic_listener.py&quot;, line 53, in trigger_callback
	File &quot;T:\InGame\Gameplay\Scripts\Server\objects\components\state.py&quot;, line 2499, in callback
	File &quot;T:\InGame\Gameplay\Scripts\Server\objects\components\state.py&quot;, line 2593, in set_state_from_stat
	File &quot;T:\InGame\Gameplay\Scripts\Server\objects\components\state.py&quot;, line 2354, in set_state
	File &quot;T:\InGame\Gameplay\Scripts\Server\objects\components\state.py&quot;, line 2404, in _trigger_on_state_changed
	File &quot;T:\InGame\Gameplay\Scripts\Server\objects\components\__init__.py&quot;, line 96, in wrapped_method
	File &quot;T:\InGame\Gameplay\Scripts\Server\objects\components\tooltip_component.py&quot;, line 412, in on_state_changed
	File &quot;T:\InGame\Gameplay\Scripts\Server\objects\components\tooltip_component.py&quot;, line 340, in update_object_tooltip
	File &quot;T:\InGame\Gameplay\Scripts\Server\objects\components\tooltip_component.py&quot;, line 429, in _ui_metadata_gen
	File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\utils\localization_tokens.py&quot;, line 402, in get_tokens
	File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\utils\localization_tokens.py&quot;, line 402, in &lt;genexpr&gt;
	File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\utils\localization_tokens.py&quot;, line 290, in _get_token
	File &quot;T:\InGame\Gameplay\Scripts\Server\tunable_utils\tunable_object_generator.py&quot;, line 30, in get_objects
	File &quot;T:\InGame\Gameplay\Scripts\Server\event_testing\resolver.py&quot;, line 819, in get_participants
ValueError: Trying to use SingleObjectResolver with something that is not an Object: ParticipantType.Actor
</desyncdata>
		</report>
</root>
*/



// WEBPACK FOOTER //
// ./src/tests/mods/participantResolverErrorTest.js